import api from '@/api'

export default {
    getSupportCountryMap({commit}) {
        return api.support_country_list().then(({data}) => {
            data.forEach(item => {
                item.areaCode = '+' + item.areaCode
                if (item.mobileRule && item.telephoneRule) {
                    item.mobileRule = item.mobileRule + '|' + item.telephoneRule
                }
            })
            commit('SET_SUPPORT_COUNTRY_MAP', data)
        })
    },
    getEmployerSupportCountryMap({commit}) {
        return api.support_employerCountry_list().then(({data}) => {
            data.forEach(item => {
                item.areaCode = '+' + item.areaCode
            })
            commit('SET_EMPLOYER_SUPPORT_COUNTRY_MAP', data)
        })
    },
    getHelperCreatorMap({commit}) {
        return api.helper_creator_list().then(({data}) => {
            commit('SET_HELPER_CREATOR_MAP', data)
        })
    },
    getInterviewCreatorMap({commit}) {
        return api.interview_creator_list().then(({data}) => {
            commit('SET_INTERVIEW_CREATOR_MAP', data)
        })
    },
    getManagerMap({commit}) {
        return api.manager_list().then(({data}) => {
            commit('SET_MANAGER_MAP', data)
        })
    },
    getCommonDictionary({commit}) {         // 获取一些在各端通用的map
        return api.common_map_get().then(({data}) => {
            commit('SET_COMMON_DICTIONARY', data)
        })
    },
    getDictionary({commit}, type:string) {           // 获取字典, 传入要查询的字典数组
        api.dictionary_get({type}).then(({data}) => {
            commit('SET_DICTIONARY', data)
        })
    },
}
